import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type NoResultsStyle = {
  noResults: CSSProperties;
  noResults__icon: CSSProperties;
  noResults__title: CSSProperties;
  noResults__text: CSSProperties;
};

const styles: NoResultsStyle = {
  noResults: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '12px',
    backgroundColor: AppColors.VA.NEUTRALS._10_,
    borderRadius: '8px',
    padding: '16px',
    marginTop: '16px',
    marginBottom: '16px'
  },
  noResults__icon: {
    fontSize: '18px',
    color: AppColors.VA.ERROR._50_,
    marginTop: '2px'
  },
  noResults__title: {
    color: AppColors.VA.NEUTRALS._90_,
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px'
  },
  noResults__text: {
    fontSize: '14px',
    marginTop: '4px',
    lineHeight: '22px',
    fontWeight: '400',
    color: AppColors.VA.NEUTRALS._60_
  }
};

export default styles;
